<template>
  <v-card>
    <form data-vv-scope="busClsTariffForm">
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4 v-if="isMatchRoute('motorBusClsTariff')">
              <v-checkbox data-vv-scope="busClsTariffForm" :label="labels.vehRegMand" v-model="busClsTariffForm.vehRegMand"></v-checkbox>
            </v-flex>
            <v-flex xs4 v-if="isMatchRoute('motorBusClsTariff')">
              <v-checkbox data-vv-scope="busClsTariffForm" :label="labels.vehValMand" v-model="busClsTariffForm.vehValMand"></v-checkbox>
            </v-flex>
            <v-flex xs4>
              <v-checkbox data-vv-scope="busClsTariffForm" :label="labels.permAppStat" v-model="busClsTariffForm.permAppStat"></v-checkbox>
            </v-flex>
            <v-flex lg6 md12 xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveGeneral">
                Update Business Class Tariff
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </form>
  </v-card>
</template>

<script>
import routeMixin from '@/mixins/route'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
export default {
  data () {
    return {
      labels: {
        vehRegMand: 'Vehicle Register Mandatory',
        vehValMand: 'Vehicle Value Mandatory',
        permAppStat: 'Permitted App Status'
      },
      busClsTariffForm: {
        busCls: null,
        desc: null,
        tarf: null,
        tarfDesc: null,
        vehRegMand: false,
        vehValMand: false,
        permAppStat: false
      },
      submitting: false
    }
  },
  computed: {
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu
    }
  },
  watch: {
    'ids.tarf': function(value) {
      this.fetchForm(value)
    }
  },
  methods: {
    async fetchForm(tarf) {
      const apiURI = this.busClsMenu.menu.busClsTariffGet
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            tarf: tarf
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.busClsTariffForm.busCls = data.busClsTariff.busCls
            this.busClsTariffForm.desc = data.busClsTariff.desc
            this.busClsTariffForm.tarf = data.busClsTariff.tarf
            this.busClsTariffForm.tarfDesc = data.busClsTariff.tarfDesc
            this.busClsTariffForm.vehRegMand = data.busClsTariff.vehRegMand
            this.busClsTariffForm.vehValMand = data.busClsTariff.vehValMand
            this.busClsTariffForm.permAppStat = data.busClsTariff.permAppStat
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doSaveGeneral() {
      this.resetMessages()
      this.resetValidator()
      this.$validator.validateAll('busClsTariffForm').then(result => {
        if (result) {
          this.doUpdateTariffForm()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdateTariffForm() {
      const apiURI = this.menu.busClsTariffUpdate
      if (apiURI) {
        try {
          const result = this.$http.put(apiURI, this.busClsTariffForm)
          const { data } = await result
          if (data) {
            this.notify(data)
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    }
  },
  mounted() {
    this.fetchForm(this.ids.tarf)
  },
  props: {
    ids: Object,
    tariff: String
  },
  mixins: [
    MessageMixin,
    routeMixin
  ]
}
</script>

<style>

</style>
